import React from "react";
import { GridToolbarQuickFilter, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';

export default function CustomToolbar(props) {
    return (
      <GridToolbarContainer sx={{ display:'flex', justifyContent: 'space-between' }}>
            {!props.hideCSV && <GridToolbarExport printOptions={{ disableToolbarButton: true }} csvOptions={props.csvOptions} />}
            {props.showQuickFilter && <GridToolbarQuickFilter />}
      </GridToolbarContainer>
    );
}
